/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HttpStatusCode } from './HttpStatusCode';
import {
	HttpStatusCodeFromJSON,
	HttpStatusCodeFromJSONTyped,
	HttpStatusCodeToJSON,
	HttpStatusCodeToJSONTyped,
} from './HttpStatusCode';

/**
 *
 * @export
 * @interface ApprovalResult
 */
export interface ApprovalResult {
	/**
	 *
	 * @type {HttpStatusCode}
	 * @memberof ApprovalResult
	 */
	statusCode?: HttpStatusCode;
	/**
	 *
	 * @type {Array<Error>}
	 * @memberof ApprovalResult
	 */
	errors?: Array<Error> | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof ApprovalResult
	 */
	succeded?: boolean;
}

/**
 * Check if a given object implements the ApprovalResult interface.
 */
export function instanceOfApprovalResult(value: object): value is ApprovalResult {
	return true;
}

export function ApprovalResultFromJSON(json: any): ApprovalResult {
	return ApprovalResultFromJSONTyped(json, false);
}

export function ApprovalResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ApprovalResult {
	if (json == null) {
		return json;
	}
	return {
		statusCode: json['statusCode'] == null ? undefined : HttpStatusCodeFromJSON(json['statusCode']),
		errors: json['errors'] == null ? undefined : json['errors'],
		succeded: json['succeded'] == null ? undefined : json['succeded'],
	};
}

export function ApprovalResultToJSON(json: any): ApprovalResult {
	return ApprovalResultToJSONTyped(json, false);
}

export function ApprovalResultToJSONTyped(
	value?: ApprovalResult | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		statusCode: HttpStatusCodeToJSON(value['statusCode']),
		errors: value['errors'],
		succeded: value['succeded'],
	};
}
